import {
  FETCH_STATE,
  FETCH_STATE_SUCCESS,
  FETCH_STATE_FAIL,
  GET_STATE,
  GET_STATE_SUCCESS,
  GET_STATE_FAIL,
  CREATE_STATE,
  CREATE_STATE_SUCCESS,
  CREATE_STATE_FAIL,
  UPDATE_STATE,
  UPDATE_STATE_SUCCESS,
  UPDATE_STATE_FAIL,
  DELETE_STATE,
  DELETE_STATE_SUCCESS,
  DELETE_STATE_FAIL,
} from 'actions/address';
import * as _ from 'lodash';
import { toast } from 'react-toastify';

const initialState = {
  isLoading: false,
  states: [],
  stateDetail: {},
  page: 1,
  limit: 10,
  totalPages: 1,
  total: 1,
};
const stateReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case FETCH_STATE:
    case GET_STATE:
    case CREATE_STATE:
    case DELETE_STATE: {
      return { ...state, isLoading: true, stateDetail: {} };
    }

    case UPDATE_STATE: {
      return { ...state, isLoading: true };
    }

    case FETCH_STATE_SUCCESS: {
      if (payload.page === 1) {
        return {
          ...state,
          isLoading: false,
          states: payload.results,
          page: payload.page,
          limit: payload.limit,
          totalPages: payload.totalPages,
          total: payload.totalResults,
        };
      } else {
        return {
          ...state,
          isLoading: false,
          states: _.concat(state.states, payload.results),
          page: payload.page,
          limit: payload.limit,
          totalPages: payload.totalPages,
          total: payload.totalResults,
        };
      }
    }

    case GET_STATE_SUCCESS: {
      return {
        ...state,
        stateDetail: payload,
        isLoading: false,
      };
    }

    case CREATE_STATE_SUCCESS: {
      toast.success('State added successfully');
      return {
        ...state,
        states: _.concat(state.states, payload),
        isLoading: false,
      };
    }

    case UPDATE_STATE_SUCCESS: {
      toast.success('State updated successfully');
      return {
        ...state,
        isLoading: false,
        states: state.states.map((data) => (data.id === payload.id ? payload : data)),
      };
    }

    case DELETE_STATE_SUCCESS: {
      toast.success('State deleted successfully');
      return {
        ...state,
        isLoading: false,
        states: state.states.filter((data) => data.id !== payload),
      };
    }

    case FETCH_STATE_FAIL:
    case GET_STATE_FAIL:
    case CREATE_STATE_FAIL:
    case UPDATE_STATE_FAIL:
    case DELETE_STATE_FAIL: {
      return {
        ...state,
        isLoading: false,
      };
    }
    default:
      return { ...state };
  }
};
export default stateReducer;
